export const GET_ESTIMATED_PRICE_REQUEST = "GET_ESTIMATED_PRICE_REQUEST";
export const GET_ESTIMATED_PRICE_SUCCESS = "GET_ESTIMATED_PRICE_SUCCESS";
export const GET_ESTIMATED_PRICE_FAILURE = "GET_ESTIMATED_PRICE_FAILURE";

export const UPDATE_ESTIMATED_PRICE_REQUEST = "UPDATE_ESTIMATED_PRICE_REQUEST";
export const UPDATE_ESTIMATED_PRICE_SUCCESS = "UPDATE_ESTIMATED_PRICE_SUCCESS";
export const UPDATE_ESTIMATED_PRICE_FAILURE = "UPDATE_ESTIMATED_PRICE_FAILURE";

export const GET_ESTIMATED_PRICE_FILTERED_REQUEST =
  "GET_ESTIMATED_PRICE_FILTERED_REQUEST";
export const GET_ESTIMATED_PRICE_FILTERED_SUCCESS =
  "GET_ESTIMATED_PRICE_FILTERED_SUCCESS";
export const GET_ESTIMATED_PRICE_FILTERED_FAILURE =
  "GET_ESTIMATED_PRICE_FILTERED_FAILURE";
